const { map, prop, pipe, flatten, uniq } = require("ramda");

const id = map(prop("id"));
const teams = map(prop("teams"));
const workplan = map(prop("workPlans"));
const rotationPolicies = map(prop("shiftRotationPolicy"));
const policies = map(prop("policies"));
const userSelection = map(prop("userSelection"));
const tags = map(prop("tags"));
const text = map(prop("text"));

export const getTagsFromRosters = pipe(
  workplan,
  flatten,
  rotationPolicies,
  policies,
  flatten,
  userSelection,
  tags,
  flatten,
  text,
  uniq
);

export const getTeamIdsForRosters = pipe(teams, flatten, id, uniq);
